(() => {
  // Emergency republish token 2026-08-16: keep until Shopify's German PDP shards have all
  // invalidated the pre-idempotence asset that could retrigger the reservation-card observer.
  document.documentElement.dataset.pkmPreorderRevision = 'flow-ring-dispatch-28-september-2026-09-23';
  // Stoq patches window.fetch later in the page lifecycle. Keep the browser-native function so
  // these exact checkout paths cannot be rewritten back into selling-plan requests.
  const nativeFetch = window.fetch.bind(window);
  const PREORDER_TARGETS = {
    // Slider Necklace, 27 cm.
    '9971886424406': {
      variants: {
        '54533167546710': {
          dateKey: 'date19',
          buttonKey: 'sliderButtonWednesday',
          sharedReservation: true,
        },
      },
    },
    // Silver Slider Necklace, 27 cm.
    '9972180517206': {
      variants: {
        '54533487853910': {
          dateKey: 'date21',
          buttonKey: 'silverSliderButton21',
          sharedReservation: true,
        },
      },
    },
    // Slider Bracelets. All three finishes and both lengths dispatch Wednesday.
    '11137023967574': {
      variants: {
        '54786025357654': { dateKey: 'date19', buttonKey: 'braceletButtonWednesday', sharedReservation: true, inventoryReservation: true },
        '54992295821654': { dateKey: 'date19', buttonKey: 'braceletButtonWednesday', sharedReservation: true, inventoryReservation: true },
      },
    },
    '11137116504406': {
      variants: {
        '54786185167190': { dateKey: 'date19', buttonKey: 'braceletButtonWednesday', sharedReservation: true, inventoryReservation: true },
        '54992296018262': { dateKey: 'date19', buttonKey: 'braceletButtonWednesday', sharedReservation: true, inventoryReservation: true },
      },
    },
    '11137245905238': {
      variants: {
        '54786849440086': { dateKey: 'date19', buttonKey: 'braceletButtonWednesday', sharedReservation: true, inventoryReservation: true },
        '54992296182102': { dateKey: 'date19', buttonKey: 'braceletButtonWednesday', sharedReservation: true, inventoryReservation: true },
      },
    },
    // Echo Drop gold. Crystal switches at real stockout to expected dispatch 24 September.
    // Lab-grown retains the same dispatch date and its separate finite batch:
    // DENY with the finite-preorder flag makes Shopify stop the sale at zero.
    '11174583501142': {
      variants: {
        '54961865523542': {
          dateKey: 'date24September',
          buttonKey: 'echoCrystalButton24September',
          inventoryReservation: true,
          sharedReservation: true,
        },
        '54961866408278': {
          dateKey: 'date24September',
          buttonKey: 'echoDiamondButton24September',
          inventoryReservation: true,
          nativePreorderButton: true,
        },
      },
    },
    // Mercury Brooch gold. Silver is a separate product and stays in normal stock, so only the
    // gold variant is listed here. `inventoryReservation` keeps this self-closing: the entry is
    // inert until the variant is actually CONTINUE + qty <= 0, and it stops on its own the moment
    // the batch lands.
    '10294859891030': {
      variants: {
        '52941222838614': {
          dateKey: 'date16September',
          buttonKey: 'mercuryButton16September',
          inventoryReservation: true,
          sharedReservation: true,
        },
      },
    },
    // Flow Ring. One variant; the 210-ring batch from Yiwu lands ahead of dispatch Monday
    // 28 September. Same self-closing rule as Mercury: inert until CONTINUE + qty <= 0, back to
    // the normal buy button on its own once the received batch makes stock positive.
    '10952403157334': {
      variants: {
        '54472803451222': {
          dateKey: 'date28September',
          buttonKey: 'flowRingButton28September',
          inventoryReservation: true,
          sharedReservation: true,
        },
      },
    },
    // Echo Drop silver-coloured. Both stones are expected to dispatch Monday 28 September: they
    // travel in the same parcel, and lab-grown followed crystal there once that parcel was held in
    // Guangzhou. Crystal switches at real stockout; lab-grown keeps its separate finite batch and
    // stays unavailable at zero.
    '11193141920086': {
      variants: {
        '55046078169430': {
          dateKey: 'date28September',
          buttonKey: 'echoSilverCrystalButton28September',
          inventoryReservation: true,
          sharedReservation: true,
        },
        // No `sharedReservation` on purpose: this mirrors the gold lab-grown entry exactly, so the
        // two metals of the same product cannot present differently. Whether both lab-grown
        // variants should also carry the shared green-check card is a separate call.
        '55046078202198': {
          dateKey: 'date28September',
          buttonKey: 'echoSilverDiamondButton28September',
          inventoryReservation: true,
          nativePreorderButton: true,
        },
      },
    },
    // Chunky Half Stud. Each finish becomes a one-time preorder only after its own genuine
    // stockout, so the remaining finish is never put on preorder prematurely.
    '10242668462422': {
      variants: {
        '52745345663318': {
          dateKey: 'date15September',
          buttonKey: 'chunkyHalfStudButton15September',
          inventoryReservation: true,
          sharedReservation: true,
        },
      },
    },
    '10963613057366': {
      variants: {
        '54511522316630': {
          dateKey: 'date15September',
          buttonKey: 'chunkyHalfStudButton15September',
          inventoryReservation: true,
          sharedReservation: true,
        },
      },
    },
    // Mikro Pearl Necklace. Every length becomes a one-time preorder only after real stockout.
    '10549154513238': {
      variants: {
        '54073020842326': {
          dateKey: 'date3September', buttonKey: 'microButtonDate3SeptemberTemplate', mobileButtonKey: 'microButtonDate3SeptemberShort', buttonLength: '36.5 cm', microReservation: true, sharedReservation: true,
        },
        '54073020875094': {
          dateKey: 'date3September', buttonKey: 'microButtonDate3SeptemberTemplate', mobileButtonKey: 'microButtonDate3SeptemberShort', buttonLength: '41 cm', microReservation: true, sharedReservation: true,
        },
        '54877813539158': {
          dateKey: 'date3September',
          buttonKey: 'microButtonDate3SeptemberTemplate',
          mobileButtonKey: 'microButtonDate3SeptemberShort',
          buttonLength: '45 cm',
          microReservation: true,
          sharedReservation: true,
        },
      },
    },
    // Mikro Pearl Bracelet without gold details. Both lengths join the 3 September batch.
    '10875882275158': {
      variants: {
        '54431922323798': {
          dateKey: 'date3September', buttonKey: 'microButtonDate3SeptemberTemplate', mobileButtonKey: 'microButtonDate3SeptemberShort', buttonLength: '15 cm', microReservation: true, sharedReservation: true,
        },
        '54431922356566': {
          dateKey: 'date3September', buttonKey: 'microButtonDate3SeptemberTemplate', mobileButtonKey: 'microButtonDate3SeptemberShort', buttonLength: '18 cm', microReservation: true, sharedReservation: true,
        },
      },
    },
    // Mikro Pearl Necklace with gold details. Every length uses the 3 September batch after stockout.
    '10599598621014': {
      variants: {
        '54072916640086': {
          dateKey: 'date3September', buttonKey: 'microButtonDate3SeptemberTemplate', mobileButtonKey: 'microButtonDate3SeptemberShort', buttonLength: '36.5 cm', microReservation: true, sharedReservation: true,
        },
        '54072916672854': {
          dateKey: 'date3September',
          buttonKey: 'microButtonDate3SeptemberTemplate',
          mobileButtonKey: 'microButtonDate3SeptemberShort',
          buttonLength: '41 cm',
          microReservation: true,
          sharedReservation: true,
        },
        '54882953560406': {
          dateKey: 'date3September', buttonKey: 'microButtonDate3SeptemberTemplate', mobileButtonKey: 'microButtonDate3SeptemberShort', buttonLength: '45 cm', microReservation: true, sharedReservation: true,
        },
      },
    },
  };
  const trackedForms = new WeakSet();

  const copy = (() => {
    try {
      return JSON.parse(document.getElementById('pkm-one-time-preorder-copy')?.textContent || '{}');
    } catch (error) {
      console.error('Could not parse the one-time preorder copy.', error);
      return {};
    }
  })();

  const dispatchProperty = (target) => {
    return [copy.dispatchPropertyName || 'Dispatch date', target.dispatchLabel || copy[target.dateKey] || ''];
  };

  const isMicroQa = () => {
    return copy.themeRole === 'unpublished'
      && new URLSearchParams(window.location.search).get('pkm_micro_preorder_qa') === '1';
  };

  const isInventoryPreorderQa = (productId, variantId) => {
    if (copy.themeRole !== 'unpublished') return false;
    const qaMode = new URLSearchParams(window.location.search);

    if (qaMode.get('pkm_echo_preorder_qa') === '1') {
      return (
        (productId === '11174583501142' && variantId === '54961865523542')
        || (productId === '11193141920086' && variantId === '55046078169430')
      );
    }

    return (
      qaMode.get('pkm_chunky_half_stud_preorder_qa') === '1'
      && (
        (productId === '10242668462422' && variantId === '52745345663318')
        || (productId === '10963613057366' && variantId === '54511522316630')
      )
    );
  };

  const isInventoryReservationActive = (variantId) => {
    return String(copy.inventoryPreorderVariantIds || '').includes(`|${variantId}|`);
  };

  const nextBatchVariants = () => (Array.isArray(copy.nextBatchVariants) ? copy.nextBatchVariants : [])
    // The batch date is Shopify data (variant metafield); Liquid renders its labels. Without a valid
    // date and both labels the batch fails closed, so no line can be sold with a blank promise.
    .filter((batch) => /^\d{4}-\d{2}-\d{2}$/.test(String(batch.dispatchDate || ''))
      && String(batch.dispatchLabel || '').trim() && String(batch.buttonLabel || '').trim() && (
      (batch.productId === '11174583501142' && batch.parentVariantId === '54961866408278')
      || (batch.productId === '11193141920086' && batch.parentVariantId === '55046078202198')
    ));

  const resolveNextBatchTarget = (productId, variantId) => {
    const batch = nextBatchVariants().find((candidate) => candidate.productId === productId
      && candidate.variantId === variantId && candidate.active === true);
    return batch ? {
      dispatchLabel: batch.dispatchLabel, buttonLabel: batch.buttonLabel,
      dispatchIso: batch.dispatchDate, inventoryReservation: true, nativePreorderButton: true,
    } : null;
  };

  const nextBatchRedirectUrl = () => {
    const batch = nextBatchVariants().find((candidate) => candidate.parentVariantId === copy.selectedVariantId
      && candidate.parentAvailable === false && candidate.available === true);
    if (!batch) return null;
    const nextUrl = new URL(window.location.href);
    if (nextUrl.searchParams.get('variant') === batch.variantId) return null;
    nextUrl.searchParams.set('variant', batch.variantId);
    return nextUrl.href;
  };

  const resolveTarget = (form) => {
    if (!(form instanceof HTMLFormElement)) return null;

    const productId = form.querySelector('input[name="product-id"]')?.value;
    const variantId = form.querySelector('input[name="id"]')?.value;
    const productTarget = PREORDER_TARGETS[productId];
    const target = productTarget?.variants?.[variantId] || resolveNextBatchTarget(productId, variantId);

    if (!target) return null;
    if (
      (productId === '9971886424406' || productId === '9972180517206')
      && !document.querySelector(`[data-pkm-slider-preorder-active="${variantId}"]`)
    ) return null;
    if (
      target.microReservation
      && !document.querySelector(`[data-pkm-micro-preorder-active="${variantId}"]`)
      && !isMicroQa()
    ) return null;
    if (
      target.inventoryReservation
      && !isInventoryReservationActive(variantId)
      && !isInventoryPreorderQa(productId, variantId)
    ) return null;

    // The stocked silver lab-grown allocation can be held for documentation without moving stock
    // to a new SKU. Its one date is supplied by Liquid, just like the separate finite batches.
    const finiteVariant = productId === '11193141920086' && variantId === '55046078202198'
      && (Array.isArray(copy.finiteVariants) ? copy.finiteVariants : []).find((candidate) =>
        candidate.variantId === variantId
        && /^\d{4}-\d{2}-\d{2}$/.test(String(candidate.dispatchDate || ''))
        && String(candidate.dispatchLabel || '').trim() && String(candidate.buttonLabel || '').trim());
    return { ...target, productId, variantId, ...(finiteVariant ? {
      dispatchIso: finiteVariant.dispatchDate,
      dispatchLabel: finiteVariant.dispatchLabel,
      buttonLabel: finiteVariant.buttonLabel,
    } : {}) };
  };

  const setStyles = (element, styles) => {
    Object.assign(element.style, styles);
    return element;
  };

  const buildSharedReservationDescription = (form) => {
    let description = form.querySelector('.restock-rocket-preorder-description');
    if (!description) {
      description = document.createElement('div');
      description.className = 'restock-rocket-preorder-description';
      form.querySelector('.restock-rocket-preorder-button')?.after(description);
    }
    if (!description.isConnected) return;
    if (description.querySelector('[data-pkm-shared-reservation-content]')) return;

    description.dataset.pkmSharedReservation = 'true';
    setStyles(description, { backgroundColor: 'rgb(255, 255, 255)', borderRadius: '0px' });
    description.replaceChildren();

    const text = setStyles(document.createElement('div'), { color: 'rgb(21, 21, 21)' });
    text.className = 'preorder-description-text';
    const shell = setStyles(document.createElement('div'), {
      margin: '-4px 0 10px 0',
      fontFamily: 'inherit',
    });
    shell.dataset.pkmSharedReservationContent = 'true';
    const lockLine = setStyles(document.createElement('div'), {
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
      margin: '0 0 10px 0', fontSize: '11px', lineHeight: '1.3', color: '#222',
    });
    const lock = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    lock.setAttribute('viewBox', '0 0 24 24');
    lock.setAttribute('width', '12');
    lock.setAttribute('height', '12');
    lock.setAttribute('fill', 'none');
    lock.setAttribute('role', 'presentation');
    lock.setAttribute('focusable', 'false');
    lock.style.cssText = 'color:#8a8f98;display:inline-block;vertical-align:-1px;flex:0 0 auto';
    lock.innerHTML = '<rect x="4" y="10.5" width="16" height="11" rx="2" fill="currentColor"></rect><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path>';
    const intro = document.createElement('span');
    intro.textContent = copy.microReservationIntro || '';
    lockLine.append(lock, intro);

    const guarantees = setStyles(document.createElement('div'), {
      border: '1px solid #eeeeee', borderRadius: '6px', padding: '12px 14px', margin: '0',
    });
    const makeGuarantee = (prefix, strongText, suffix, last = false) => {
      const row = setStyles(document.createElement('div'), {
        display: 'flex', alignItems: 'center', gap: '12px',
        margin: last ? '0' : '0 0 9px 0', fontSize: '13px', lineHeight: '1.35',
      });
      const bullet = setStyles(document.createElement('span'), {
        width: '24px', height: '24px', borderRadius: '50%', background: '#1f8f3a',
        color: '#ffffff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '15px', lineHeight: '1', flex: '0 0 auto',
      });
      bullet.textContent = '✓';
      const label = document.createElement('span');
      if (prefix) label.append(document.createTextNode(`${prefix} `));
      const strong = document.createElement('strong');
      strong.textContent = strongText;
      label.append(strong);
      if (suffix) label.append(document.createTextNode(` ${suffix}`));
      row.append(bullet, label);
      return row;
    };
    guarantees.append(
      makeGuarantee(copy.microGuaranteePrefix, copy.microGuaranteeStrong, '', false),
      makeGuarantee('', copy.microCancelStrong, copy.microCancelSuffix, true)
    );
    shell.append(lockLine, guarantees);
    text.append(shell);
    description.append(text);
  };

  // Echo Drop still uses Stoq's own card. This fallback must be idempotent: changing the same
  // German label repeatedly would retrigger the document MutationObserver and lock the page.
  const syncSharedGermanGuaranteeCopy = (form) => {
    const description = form.querySelector('.restock-rocket-preorder-description');
    if (!description || copy.microGuaranteePrefix !== 'Garantiert') return;

    const guaranteeStrong = Array.from(description.querySelectorAll('strong')).find((element) => {
      return element.textContent.includes('nächsten Lieferung');
    });
    const guaranteeLabel = guaranteeStrong?.parentElement;
    if (!guaranteeLabel || guaranteeLabel.tagName !== 'SPAN') return;

    const desiredText = `${copy.microGuaranteePrefix} ${copy.microGuaranteeStrong}`.trim();
    if (
      guaranteeLabel.textContent.trim() === desiredText
      && guaranteeStrong.textContent.trim() === copy.microGuaranteeStrong
    ) return;

    guaranteeLabel.replaceChildren(document.createTextNode(`${copy.microGuaranteePrefix} `));
    const strong = document.createElement('strong');
    strong.textContent = copy.microGuaranteeStrong;
    guaranteeLabel.append(strong);
  };

  const updatePreorderButton = (form) => {
    const target = resolveTarget(form);
    const buttonKey = target?.mobileButtonKey && window.matchMedia('(max-width: 699px)').matches
      ? target.mobileButtonKey
      : target?.buttonKey;
    const buttonTemplate = target?.buttonLabel || (buttonKey ? copy[buttonKey] : '');
    const buttonText = target?.buttonLength
      ? String(buttonTemplate).replace('__LENGTH__', target.buttonLength)
      : buttonTemplate;
    if (!buttonText) return;

    const linkedBuyButtons = Array.from(document.querySelectorAll('buy-buttons[form]'))
      .filter((element) => element.getAttribute('form') === form.getAttribute('id') && !form.contains(element));

    if (target.sharedReservation || target.nativePreorderButton) {
      const preorderButton = form.querySelector('buy-buttons button[type="submit"]');
      if (preorderButton && !preorderButton.matches('.restock-rocket-preorder-button')) {
        preorderButton.disabled = false;
        preorderButton.classList.add('restock-rocket-preorder-button');
        const content = preorderButton.querySelector(':scope > div') || preorderButton;
        const label = document.createElement('span');
        label.className = 'cart-icon';
        label.style.cssText = 'display:flex;justify-content:center;white-space:nowrap';
        content.replaceChildren(label);
      }

      linkedBuyButtons.forEach((element) => {
        const linkedButton = element.querySelector('button[type="submit"]');
        if (!linkedButton || linkedButton.matches('.restock-rocket-preorder-button')) return;
        linkedButton.disabled = false;
        linkedButton.classList.add('restock-rocket-preorder-button');
        const content = linkedButton.querySelector(':scope > div') || linkedButton;
        const label = document.createElement('span');
        label.className = 'cart-icon';
        label.style.cssText = 'display:flex;justify-content:center;white-space:nowrap';
        content.replaceChildren(label);
      });
    }

    form.querySelectorAll('.restock-rocket-preorder-button .cart-icon').forEach((label) => {
      if (label.textContent !== buttonText) label.textContent = buttonText;
    });
    linkedBuyButtons.forEach((element) => {
      const label = element.querySelector('.restock-rocket-preorder-button .cart-icon');
      if (!label) return;
      if (label.textContent !== buttonText) label.textContent = buttonText;
    });

    if (target.sharedReservation) buildSharedReservationDescription(form);
    syncSharedGermanGuaranteeCopy(form);
  };

  const updateSliderStockCard = () => {
    const stockCopy = document.querySelector('[data-pkm-slider-stock-delivery]');
    if (!stockCopy) return;

    const generic = copy.sliderCardDeliveryGeneric || '';
    const prefix = copy.sliderCardDeliveryPrefix || '';
    const weekdays = String(copy.sliderCardWeekdays || '').split(',');
    const nowParts = {};
    const qaTime = copy.themeRole === 'unpublished'
      ? new URLSearchParams(window.location.search).get('pkm_slider_card_time')
      : '';
    const qaMatch = qaTime?.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
    if (qaMatch) {
      const qaDate = new Date(Date.UTC(Number(qaMatch[1]), Number(qaMatch[2]) - 1, Number(qaMatch[3])));
      nowParts.weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][qaDate.getUTCDay()];
      nowParts.hour = qaMatch[4];
      nowParts.minute = qaMatch[5];
      nowParts.second = '00';
    } else {
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Copenhagen', hour12: false,
        weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
      }).formatToParts(new Date()).forEach((part) => {
        if (part.type !== 'literal') nowParts[part.type] = part.value;
      });
    }

    const weekdayIndex = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(nowParts.weekday);
    const seconds = Number(nowParts.hour === '24' ? 0 : nowParts.hour) * 3600
      + Number(nowParts.minute) * 60 + Number(nowParts.second);
    let deliveryIndex = null;

    // DK/GLS keeps the precise next-day promise through Friday's 14:45 cutoff. DHL markets use
    // each locale's delivery interval (2–4 working days for DE/NL/BE).
    if (Shopify.country === 'DK' && weekdays.length === 7) {
      const cutoffSeconds = 14 * 3600 + 45 * 60;
      if (weekdayIndex >= 1 && weekdayIndex <= 4 && seconds < cutoffSeconds) deliveryIndex = weekdayIndex + 1;
      if (weekdayIndex === 5 && seconds < cutoffSeconds) deliveryIndex = 6;
    }

    stockCopy.textContent = deliveryIndex == null ? generic : `${prefix} ${weekdays[deliveryIndex]}`;
  };

  const removeSellingPlan = (form) => {
    if (!resolveTarget(form)) return;

    form.querySelectorAll('input[name="selling_plan"]').forEach((input) => input.remove());
  };

  const makeOneTimePreorder = (event) => {
    const form = event.currentTarget;
    const target = resolveTarget(form);
    if (!target) return;

    const [propertyName, propertyValue] = dispatchProperty(target);

    event.formData.delete('selling_plan');
    event.formData.set(`properties[${propertyName}]`, propertyValue);
    event.formData.set('properties[_pkm_one_time_preorder]', 'true');
    if (target.dispatchIso) event.formData.set('properties[_pkm_preorder_dispatch]', target.dispatchIso);
  };

  const addOneTimePreorder = async (form) => {
    const target = resolveTarget(form);
    if (!target) return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const submitButtons = Array.from(form.elements).filter((element) => element.type === 'submit');
    submitButtons.forEach((button) => {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-busy', 'true');
    });

    const sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    try {
      const [propertyName, propertyValue] = dispatchProperty(target);
      const formData = new FormData(form);

      // Stoq listens to `formdata` and may add the plan again after our listener. Build a pristine
      // JSON line item from the finished FormData so a selling-plan field can never cross the
      // request boundary. Preserve legitimate line-item properties added by the theme/A-B test.
      const properties = {};
      for (const [key, value] of formData.entries()) {
        const propertyMatch = key.match(/^properties\[(.+)]$/);
        if (propertyMatch && typeof value === 'string') properties[propertyMatch[1]] = value;
      }
      properties[propertyName] = propertyValue;
      properties._pkm_one_time_preorder = 'true';
      if (target.dispatchIso) properties._pkm_preorder_dispatch = target.dispatchIso;

      const requestBody = {
        items: [{
          id: Number(target.variantId),
          quantity: Number(formData.get('quantity')) || 1,
          properties,
        }],
        sections: sectionsToBundle,
        sections_url: `${Shopify.routes.root}variants/${target.variantId}`,
      };

      const response = await nativeFetch(`${Shopify.routes.root}cart/add.js`, {
        body: JSON.stringify(requestBody),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      const responseJson = await response.json();

      if (!response.ok) {
        form.dispatchEvent(
          new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: responseJson.description || responseJson.message },
          })
        );
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      if (
        window.themeVariables.settings.cartType === 'page' ||
        window.themeVariables.settings.pageType === 'cart'
      ) {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }

      const cartContent = await (await nativeFetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent.sections = responseJson.sections || {};
      const addedItems = Object.prototype.hasOwnProperty.call(responseJson, 'items')
        ? responseJson.items
        : [responseJson];

      form.dispatchEvent(
        new CustomEvent('variant:add', {
          bubbles: true,
          detail: { items: addedItems, cart: cartContent },
        })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart: cartContent },
        })
      );
    } catch (error) {
      console.error('Could not add the one-time preorder.', error);
      form.dispatchEvent(
        new CustomEvent('cart:error', {
          bubbles: true,
          detail: { error: 'Could not add this item to the cart.' },
        })
      );
    } finally {
      submitButtons.forEach((button) => {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-busy');
      });
    }
  };

  const prepareForm = (form) => {
    if (!resolveTarget(form)) return;

    removeSellingPlan(form);
    updatePreorderButton(form);

    if (!trackedForms.has(form)) {
      form.addEventListener('formdata', makeOneTimePreorder);
      trackedForms.add(form);
    }
  };

  const isConfiguredProductForm = (form) => {
    if (!(form instanceof HTMLFormElement)) return false;

    const productId = form.querySelector('input[name="product-id"]')?.value;
    return Boolean(PREORDER_TARGETS[productId]);
  };

  const scan = (root = document) => {
    if (root instanceof HTMLFormElement) prepareForm(root);
    if (root instanceof Element) root.closest('form') && prepareForm(root.closest('form'));

    root.querySelectorAll?.('form').forEach(prepareForm);
  };

  const scheduleProductRerenderScan = (form) => {
    if (!isConfiguredProductForm(form)) return;

    // The theme emits product:rerender before its product blocks have all been swapped. Stoq can
    // then patch the replacement button once more. Re-scan the exact configured product through
    // those render passes; resolveTarget() still requires the exact live preorder marker, so a
    // stocked length or unrelated product can never inherit the preorder CTA.
    [0, 80, 220, 500, 1000, 1800].forEach((delay) => {
      window.setTimeout(() => scan(document), delay);
    });
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : event.target.closest?.('form');
      if (!form) return;

      prepareForm(form);
      removeSellingPlan(form);

      if (resolveTarget(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        void addOneTimePreorder(form);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      if (event.target instanceof HTMLInputElement && event.target.name === 'id') {
        queueMicrotask(() => prepareForm(event.target.form));
      }
    },
    true
  );

  document.addEventListener(
    'product:rerender',
    (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      scheduleProductRerenderScan(form);
    },
    true
  );

  const observer = new MutationObserver((mutations) => {
    let sliderCardWasRendered = false;
    const configuredFormsToRescan = new Set();

    mutations.forEach((mutation) => {
      const mutationElement = mutation.target instanceof Element
        ? mutation.target
        : mutation.target.parentElement;
      const mutationForm = mutationElement?.closest('form');
      if (isConfiguredProductForm(mutationForm)) configuredFormsToRescan.add(mutationForm);

      mutation.addedNodes.forEach((node) => {
        scan(node);
        if (
          node instanceof Element
          && (node.matches('[data-pkm-slider-length-card]') || node.querySelector('[data-pkm-slider-length-card]'))
        ) sliderCardWasRendered = true;
      });
    });

    // Stoq sometimes wins the mobile cold-load race by replacing only the existing button's
    // text node after the scheduled scans. That is a childList mutation on the button, not a new
    // form. Re-scan that exact allowlisted form. The text write above is value-guarded, so our own
    // restoration settles after one observer pass instead of creating a feedback loop.
    configuredFormsToRescan.forEach(prepareForm);

    if (sliderCardWasRendered) updateSliderStockCard();
  });

  const start = () => {
    const nextUrl = nextBatchRedirectUrl();
    if (nextUrl) {
      window.location.replace(nextUrl);
      return;
    }
    scan(document);
    updateSliderStockCard();
    observer.observe(document.documentElement, { childList: true, subtree: true });

    // Stoq can finish by changing only an existing button's text/class, which does not add an
    // element for the MutationObserver to scan. Re-apply the exact target copy after its normal
    // render passes; unrelated forms still fail closed in resolveTarget().
    [150, 500, 1200].forEach((delay) => window.setTimeout(() => scan(document), delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
